import { render, staticRenderFns } from "./registerPlantationStep2.vue?vue&type=template&id=25f1530d&"
import script from "./registerPlantationStep2.vue?vue&type=script&lang=js&"
export * from "./registerPlantationStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports